const state = {
    barcodeScanner: null,
    barcodeScanned: null
};

const getters = {
    barcodeScanner: state => state.barcodeScanner,
    barcodeScanned: state => state.barcodeScanned
};

const actions = {

    setBarcodeScanner({commit}, barcodeScanner) {
        return new Promise((resolve) => {
            commit('SET_BARCODE_SCANNER', barcodeScanner);
            resolve();
        });
    },

    destroyBarcodeScanner({state}) {
        return new Promise((resolve) => {
            if (!state.barcodeScanner || state.barcodeScanner.destroyed) {
                return resolve();
            }

            state.barcodeScanner.destroy();

            let timesLooped = 0;
            while (state.barcodeScanner.destroyed === false) {

                if (timesLooped >= 15) {
                    window.location.reload();
                }

                timesLooped++;
            }

            resolve();
        });
    },

    setBarcodeScanned({commit}, barcodeScanned) {
        commit('SET_BARCODE_SCANNED', barcodeScanned);
    },

};

const mutations = {
    SET_BARCODE_SCANNER(state, barcodeScanner) {
        state.barcodeScanner = barcodeScanner;
    },

    SET_BARCODE_SCANNED(state, barcodeScanned) {
        state.barcodeScanned = barcodeScanned;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}